/**
 * Handoff of the selected product row from the catalog grid to the insert page.
 * Uses sessionStorage so a new browser tab can read the same product snapshot.
 * Falls back to GetProducts on the page if missing (e.g. stale session).
 */

const STORAGE_PREFIX = "catalog-insert-product:";

export function stashSelectedCatalogProduct(row) {
  if (!row || row.productId == null) return;
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${row.productId}`, JSON.stringify(row));
  } catch {
    /* quota / private mode */
  }
}

export function readStashedCatalogProduct(productId) {
  if (productId == null) return null;
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${productId}`);
    if (!raw) return null;
    const row = JSON.parse(raw);
    if (row && String(row.productId) === String(productId)) return row;
  } catch {
    /* ignore */
  }
  return null;
}

/** @deprecated Use stashSelectedCatalogProduct */
export function setSelectedCatalogProduct(row) {
  stashSelectedCatalogProduct(row);
}

/** @deprecated Use readStashedCatalogProduct */
export function takeSelectedCatalogProduct(productId) {
  return readStashedCatalogProduct(productId);
}
